import { Component, Prop } from 'vue-property-decorator';
import { Block } from '@/helpers/components';
import { BaseBlock } from '@/blocks/base-block';
import { apartmentSimilarProductsData } from './apartment-similar-products.data';
import { InstanceType } from '@/enums/InstanceType';
import { ApartmentMicroDTO } from '../../../model/ApartmentMicroDTO';


@Block(apartmentSimilarProductsData) @Component
export class ApartmentSimilarProductsBlock extends BaseBlock {
	@Prop() similarProducts: ApartmentMicroDTO[];

	reactive: boolean = true;	// to make isFavorite reactive at least to a change to this variable

	customBoIdMapping(number: string) {
		return { [InstanceType.Apartment]: number }
	}

	isFavorite(apartment: ApartmentMicroDTO, reactive: boolean) {
		return this.$cookiesService.getFavoriteProducts().includes(apartment.catalogNumber);
	}

	toggleFavorite(catalogNumber: string, to: boolean) {
		this.$cookiesService.setFavoriteProducts(to ? this.$cookiesService.getFavoriteProducts().concat(catalogNumber) : this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.reactive = !this.reactive;
	}

	get isPreview() {
		return this.$route.query.predbezne && this.$route.query.csh;
	}

	get detailLinkPreviewSuffix() {
		return this.$route.query.predbezne && this.$route.query.csh ? `?csh=${this.$route.query.csh}&predbezne=${this.$route.query.predbezne}` : '';
	}
}

export default ApartmentSimilarProductsBlock;
